export enum AccountsPayableLinkStatus {
  UNKNOWN = 'UNKNOWN',
  ACTIVE = 'ACTIVE',
  CONFIRMED = 'CONFIRMED',
  FUNDED = 'FUNDED',
  ON_DISPERSION = 'ON_DISPERSION',
  DISPERSION_SUCCESS = 'DISPERSION_SUCCESS',
  PARTIALLY_DISPERSED = 'PARTIALLY_DISPERSED',
  DISPERSION_ERROR = 'DISPERSION_ERROR',
  CANCELED = 'CANCELED',
  DISPERSION_FAIL = 'DISPERSION_FAIL',
}

export enum AccountsPayableLinkUpdateStatus {
  CONFIRMED = 'CONFIRMED',
  CANCELED = 'CANCELED',
}

export const accountsPayableLinkStep = {
  [`${AccountsPayableLinkStatus.ACTIVE}`]: 0,
  [`${AccountsPayableLinkStatus.CONFIRMED}`]: 1,
  [`${AccountsPayableLinkStatus.FUNDED}`]: 2,
  [`${AccountsPayableLinkStatus.ON_DISPERSION}`]: 2,
  [`${AccountsPayableLinkStatus.PARTIALLY_DISPERSED}`]: 3,
  [`${AccountsPayableLinkStatus.DISPERSION_SUCCESS}`]: 3,
  [`${AccountsPayableLinkStatus.DISPERSION_ERROR}`]: 3,
  [`${AccountsPayableLinkStatus.DISPERSION_FAIL}`]: 3,
};

export enum AccountsPayableLinkErrorCodes {
  NOT_FOUND = 'NOTFOUND',
}

export enum Currencies {
  mxn = 'MXN',
  usd = 'USD',
}

export const locales = {
  [`${Currencies.mxn}`]: 'es-MX',
  [`${Currencies.usd}`]: 'en-US',
  '': 'es-MX',
};

export enum QueryParams {
  CONFIRM = 'confirm',
}

export const AccountsPayableLinkErrorMsg = {
  DISPERSION_FAIL_REVIEW_BANK_ACCOUNT: 'CLABE inválida',
  INVALID_CURRENCY: 'Moneda inválida',
  INVALID_BANK_ACCOUNT: 'CLABE inválida',
  INVALID_CURRENCY_AND_BANK_ACCOUNT: 'CLABE y moneda inválidas',
  DISPERSION_FAIL: 'Dispersión fallida',
  RETURNED: 'Devuelto',
  REFUNDED: 'Devuelto',
  // ARCUS CODES
  PAYMENT_REQUEST_CANNOT_BE_PROCESSED: 'Algo salió mal, el pago no pudo ser completado',
  THE_PROVIDED_TRANSACTION_INSTRUMENTS_ARE_NOT_VALID: 'El instrumento de transacción no es válido',
  NOT_SUFFICIENT_FUNDS: 'Fondos insuficientes',
  SOURCE_ACCOUNT_IS_CLOSED: 'La cuenta de origen está cerrada',
  TRANSACTION_INSTRUMENTS_ARE_NOT_ASSIGNED_TO_THIS_CUSTOMER:
    'El instrumento de transacción no pertenece al cliente',
  DESTINATION_ACCOUNT_IS_NOT_AVAILABLE: 'La cuenta destino no está disponible',
  MAXIMUN_DAILY_AGGREGATED_LIMIT_SURPASSED: 'El límite máximo de fondeo diario ha sido excedido',
  MAXIMUM_TRANSACTION_LIMIT_SURPASSED: 'El límite máximo de transacciones ha sido excedido',
  PAYMENT_PROCESSING_HAS_FAILED: 'Algo salió mal, el pago no pudo ser completado',
  PAYMENT_RAIL_IS_NOT_AVAILABLE_AT_THIS_TIME: 'La vía de pago no está disponible en este momento',
  PAYMENT_RAIL_CANNOT_PROCESS_THE_PAYMENT_AT_THIS_TIME:
    'La vía de pago no puede procesar el pago en este momento',
  INVALID_CHARACTERS_IN_THE_PAYMENT_DESCRIPTION: 'Caracteres no válidos en la descripción del pago',
  INVALID_ACCOUNT_NUMBER: 'CLABE inválida',
  THE_ACCOUNT_NUMBER_DOESNT_MATCH_ANY_VALID_FINANCIAL_INSTITUTIONS:
    'La CLABE bancaria no pertenece a ninguna institución financiera válida',
  INVALID_ACCOUNT_HOLDER_NAME_MUST_BE_255_CHARACTERS_OR_LESS:
    'El nombre del beneficiario no es válido, debe tener un máximo de 255 caracteres',
  INVALID_ACCOUNT_HOLDER_NAME_FORMAT: 'El nombre del beneficiario tiene un formato no válido',
  PAYMENT_REQUEST_CANNOT_BE_PROCESSED_INCOMING_TRANSACTION_LIMIT_HAS_BEEN_REACHED:
    'El pago no pudo ser procesado, el límite máximo de depósito ha sido excedido',
  THE_NETWORK_IS_UNABLE_TO_COMPLETE_THE_TRANSACTION: 'La red SPEI no pudo completar la transacción',
  DESTINATION_ACCOUNT_DOESNT_EXIST: 'La cuenta destino no existe',
  BLOCKED_ACCOUNT: 'Cuenta bloqueada',
  CANCELED_ACCOUNT: 'Cuenta cancelada',
  INCORRECT_CURRENCY_RELATED_TO_THE_ACCOUNT: 'Moneda incorrecta relacionada con la cuenta',
  ACCOUNT_DOESNT_BELONG_TO_THE_DESTINATION_PARTICIPANT:
    'La cuenta destino no pertenece al banco relacionado',
  MISSING_MANDATORY_INFORMATION_TO_COMPLETE_THE_PAYMENT: 'Falta información para completar el pago',
  INVALID_CHARACTER: 'Carácter inválido',
  AUTHORIZED_ACCOUNTS_BALANCE_LIMIT_EXCEEDED:
    'La cuenta beneficiaria ha excedido el límite de balance mensual autorizado',
  ACCOUNTS_MONTHLY_CREDIT_TRANSACTIONS_EXCEEDED:
    'La cuenta beneficiaria ha excedido el número de depósitos mensuales',
  ADDITIONAL_ACCOUNT_DOESNT_RECEIVE_PAYMENTS_DIFFERENT_THAN_BANXICOS_SENDING:
    'Cuenta adicional no recibe pagos diferentes a los que envía Banxico',
  RESULT_OF_THE_RESOLUTION_RELATED_TO_THE_CLIENT_PROTECTION_COLLABORATION_AGREEMENT:
    'Algo salió mal, el pago no pudo ser completado',
  DUPLICATED_TRACKING_ID_BY_THE_TRANSMITTER_PARTICIPANT_WITHIN_THE_SAME_OPERATIONAL_DAY:
    'Clave de rastreo duplicada por el participante transmisor dentro del mismo día operativo',
  TRANSMITTER_PARTICIPANT_CERTIFICATE_EXPIRED: 'Certificado del participante transmisor vencido',
  DESTINATION_ACCOUNT_IS_BLOCKED: 'La cuenta destino está bloqueada',
  // FINTOC ERROR CODES
  // Account errors
  DESTINATION_ACCOUNT_IS_CLOSED: 'La cuenta destino está cerrada',
  DESTINATION_ACCOUNT_IS_FROZEN: 'La cuenta destino está congelada',
  DESTINATION_ACCOUNT_NOT_FOUND: 'La cuenta destino no fue encontrada',
  DESTINATION_ACCOUNT_IS_INACTIVE: 'La cuenta destino está inactiva',
  INVALID_ACCOUNT_TYPE: 'El tipo de cuenta no es válido',
  // CLABE validation errors
  INVALID_CLABE: 'La CLABE ingresada no es válida',
  INVALID_INSTITUTION_ID: 'El código de institución bancaria no es válido',
  INVALID_CLABE_CHECK_DIGIT: 'El dígito verificador de la CLABE es incorrecto',
  // Holder errors
  INVALID_HOLDER_ID: 'El RFC o CURP del beneficiario no es válido',
  INVALID_HOLDER_NAME: 'El nombre del beneficiario no es válido',
  // Balance/Limits errors
  INSUFFICIENT_FUNDS: 'Fondos insuficientes para realizar el pago',
  EXCEEDS_TRANSFER_LIMITS: 'El monto excede los límites de transferencia permitidos',
  // Currency errors
  CURRENCY_NOT_SUPPORTED: 'La moneda seleccionada no está soportada',
  // Transfer errors
  DUPLICATE_TRANSFER: 'Esta transferencia ya fue procesada anteriormente',
  AUTHORIZATION_REVOKED: 'La autorización para esta transferencia fue revocada',
  COULD_NOT_PROCESS_TRANSFER: 'No fue posible procesar la transferencia',
  // Institution errors
  REJECTED_BY_INSTITUTION: 'La transferencia fue rechazada por la institución bancaria',
  RETURNED_BY_INSTITUTION: 'La transferencia fue devuelta por la institución bancaria',
  // API/Request errors
  INVALID_COMMENT_SIZE: 'El concepto de pago excede el tamaño permitido',
  MISSING_REQUIRED_PARAMETER: 'Falta información requerida para procesar el pago',
  INVALID_REQUEST: 'La solicitud de pago contiene datos inválidos',
  FINTOC_API_ERROR: 'Error al procesar el pago, intente nuevamente',
  AUTHENTICATION_ERROR: 'Error de autenticación al procesar el pago',
  // Default
  UNKNOWN_ERROR: 'Ocurrió un error desconocido al procesar el pago',
  // MONATO ERROR CODES
  PAYMENT_TYPE_ERROR: 'Tipo de pago erróneo',
  ACCOUNT_TYPE_ERROR: 'Tipo de cuenta no corresponde',
  MOBILE_PHONE_NOT_REGISTERED: 'Número de línea de telefonía móvil no registrado',
  ADDITIONAL_ACCOUNT_NOT_ACTIVE: 'Cuenta adicional no recibe pagos que proceden de Banxico',
  ADDITIONAL_INFORMATION_INVALID: 'Estructura de la información adicional incorrecta',
  MISSING_INFORMATION_FOR_MONEY_OUT:
    'Falta instrucción para dispersar recursos de clientes por alcanzar límite al saldo',
  PAYMENT_NOT_ACCEPTED: 'Pago opcional no aceptado por el participante receptor',
  CODI_PAYMENT_NO_REDUCED_TIME: 'Tipo de pago CoDi sin notificación de abono en tiempo reducido',
};
